import {
  CheckIcon,
  LockIcon,
  ClipboardIcon,
  FlashIcon,
  TaskIcon,
} from '../../assets/icons/jira-icons';
import vulnerabilityIcon from '../../assets/icons/vulnerabilityIcon.png';

const iconMap = {
  bug: LockIcon,
  task: CheckIcon,
  story: ClipboardIcon,
  epic: FlashIcon,
  custom: TaskIcon,
  vulnerability: vulnerabilityIcon,
};

export const IssueTypeIcon = ({
  issueType = 'custom',
  size = 16,
  color,
  icon,
  ...props
}) => {
  const type = issueType?.toLowerCase() || 'custom';
  
  if (type === 'vulnerability') {
    return (
      <img
        src={vulnerabilityIcon}
        alt={type}
        width={size}
        height={size}
        {...props}
      />
    );
  }
  
  else if (icon) {
    return <img src={icon} alt={type} width={size} height={size} {...props} />;
  } 
    else {
    const IconComponent = iconMap[type] || TaskIcon;

    return (
      <IconComponent
        size={size}
        color={color || getDefaultColor(type)}
        {...props}
      />
    );
  }
};

const getDefaultColor = (type) => {
  switch (type) {
    case 'bug':
      return '#F15B50';
    case 'task':
      return '#4688EC';
    case 'story':
      return '#6A9A23';
    case 'epic':
      return '#BF63F3';
    case 'custom':
      return '#FFAB00';
    default:
      return '#7A869A'; // default for custom or unknown
  }
};